module.exports = __webpack_public_path__ + "static/img/38.ccaecad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/38.jpg
// module id = UKVI
// module chunks = 0